

































import { defineComponent, computed, PropType } from '@nuxtjs/composition-api'
import { FilterOption, Filters } from '~/models/statistics/types'
import SelectedFilterButton from '~/components/plot/price-trends/SelectedFilterButton.vue'

export default defineComponent({
  components: { SelectedFilterButton },
  props: {
    filters: {
      type: Object as PropType<Filters>,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const selectedFilters = computed(() => {
      const selectedOptions: { [filterType: string]: FilterOption[] } = {}
      Object.keys(props.filters).forEach(key => {
        selectedOptions[key] = props.filters[
          key as keyof Filters
        ].options.filter(option =>
          props.filters[key as keyof Filters].selected.includes(
            option.value as never
          )
        )
      })
      return selectedOptions
    })

    const removeFilter = (type: string, value: number) => {
      emit('change-filter', {
        type,
        value
      })
    }

    return {
      selectedFilters,
      removeFilter
    }
  }
})
